﻿import { LiveDataSetStation, LiveDataSetValue } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject } from "./IStationValueFormatter";

export class WmoToMetarWeatherFormatter implements IStationValueFormatter {

    constructor() {
    }

    public getShortName(): string {
        return "Present Weather";
    }

    public getUnits(): string {
        return null;
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return ParameterGroupInfoSet.PresentWeather;
    }

    public getDescription(): string {
        return "Present Weather in METAR coding format.";
    }

    public getId(): string {
        return null;
    }

    public getSensorId(): string | undefined {
        return undefined;
    }

    public plottable(): boolean {
        return false;
    }

    public axisMin(): number {
        return null;
    }

    public axisMax(): number {
        return null;
    }

    public plotLines(): boolean {
        return false;
    }

    private regex = /(\d+)/;
    private metarRegex = /^[\+-]?[A-Z]*$/;

    public format(liveDataSetStation: LiveDataSetStation, warningRules?: WarningGroup): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        }

        if (ParameterGroupInfoSet.PresentWeather.Id in liveDataSetStation.GroupValues) {

            const wmo: LiveDataSetValue = liveDataSetStation.GroupValues[ParameterGroupInfoSet.PresentWeather.Id][0];
            const paramDef = DefaultParameterDefinitions.Parameters[wmo.Parameter];

            // the default if parameter exists but has expired
            valueObject = {
                Value: '///',
                Status: wmo.ExpiryStatus,
                WarningThreshold: null,
                ParameterDefinition: paramDef,
                Timestamp: wmo.Timestamp,
                Sensor: wmo.Sensor
            }

            const result = this.regex.exec(wmo.Value);

            if (result !== null && result.length > 0) {
                const pos = parseInt(result[1], 10);

                if (pos < this.metarCodes.length) {
                    valueObject.Value = this.metarCodes[pos];
                }
            } else {
                const metarResult = this.metarRegex.exec(wmo.Value);

                if (metarResult !== null) {
                    valueObject.Value = wmo.Value;
                }
            }
        }

        return valueObject;
    }

    private metarCodes = ["NIL", "", "", "", "HZ", "HZ", "", "", "", "", "BR", "SG",
        "VCTS", "", "", "", "", "", "SQ", "", "", "", "", "", "", "", "", "BLSA", "BLSA", "BLSA",
        "FG", "BCFG", "FG", "FG", "FG", "FZFG", "", "", "", "", "UP", "UP", "+UP", "UP", "+UP", "UP",
        "+UP", "UP", "+UP", "", "DZ", "-DZ", "DZ", "+DZ", "-FZDZ", "FZDZ", "+FZDZ", "-RADZ", "+RADZ",
        "RADZ", "RA", "-RA", "RA", "+RA", "-FZRA", "FZRA", "+FZRA", "-RASN", "+RASN", "RASN", "SN",
        "-SN", "SN", "+SN", "-PL", "PL", "+PL", "SG", "IC", "GS", "SHUP", "-SHRA", "SHRA", "+SHRA",
        "+SHRA", "-SHSN", "SHSN", "+SHSN", "", "SHGR"];
}